import axiosInstance from '../../utils/http-client';
import { EmailTemplateType, SentEmailApplicantElement } from '@models/email-templates';

export const getEmailTemplates = (): Promise<Array<EmailTemplateType>> => {
  return axiosInstance.get(`/api/v1/app/email/templates`, {});
};

export const getEmailTemplate = (id: string): Promise<EmailTemplateType> => {
  return axiosInstance.get(`/api/v1/app/email/templates/${id}`, {});
};

export const getEmailTemplateReplaceParams = (
  id: string,
  positionId?: string,
  applicantId?: string,
): Promise<EmailTemplateType> => {
  const parameters: { params: any; paramsSerializer: any } = {
    params: {},
    paramsSerializer: { indexes: null },
  };

  if (positionId) {
    parameters.params.positionId = positionId;
  }

  if (applicantId) {
    parameters.params.applicantId = applicantId;
  }

  return axiosInstance.get(`/api/v1/app/email/templates/${id}/replaceParams`, parameters);
};

export const deleteEmailTemplate = (id: string): Promise<Array<EmailTemplateType>> => {
  return axiosInstance.delete(`/api/v1/app/email/templates/${id}`, {});
};

export const getSentEmailTemplates = (
  applicantId: string,
  positionId: string,
): Promise<Array<SentEmailApplicantElement>> => {
  return axiosInstance.get(`/api/v1/app/email/sent?applicantId=${applicantId}&positionId=${positionId}`, {});
};

export const createEmailTemplate = (
  title: string,
  body: string,
  subject: string,
): Promise<Array<EmailTemplateType>> => {
  return axiosInstance.post('/api/v1/app/email/templates', {
    title: title,
    body: body,
    subject: subject,
  });
};

export const patchEmailTemplate = (
  id: string,
  title?: string,
  body?: string,
  subject?: string,
): Promise<Array<EmailTemplateType>> => {
  return axiosInstance.patch(`/api/v1/app/email/templates/${id}`, {
    title: title,
    body: body,
    subject: subject,
  });
};

export const sendEmailService = (
  positionId: string,
  applicantId: number,
  templateId: string,
  subject: string,
  body: string,
  stepId: number,
): Promise<Array<EmailTemplateType>> => {
  return axiosInstance.post(`/api/v1/app/email/send?applicantId=${applicantId}&positionId=${positionId}`, {
    templateId: templateId,
    subject: subject,
    body: body,
    stepId: stepId,
  });
};
